// client/src/components/wetakeover/TierSelection.jsx
import React from 'react';

const TierSelection = ({ selectedTier, onSelect }) => {
  const tiers = [
    {
      id: 'mid',
      name: 'Mid-Tier KOLs',
      icon: '⭐',
      impressions: '500-1000 avg impressions',
      qrtCost: 100,
      features: ['Authentic engagement', 'Cost-effective reach', 'Niche audiences'],
    },
    {
      id: 'high',
      name: 'High-Tier KOLs',
      icon: '💎',
      impressions: '1500+ avg impressions',
      qrtCost: 180,
      features: ['Premium content', 'Maximum visibility', 'Brand authority'],
    },
  ];

  return (
    <div className="ui-motion-enter space-y-8 max-w-4xl mx-auto">
      <div className="text-center">
        <h2 className="text-3xl md:text-5xl font-bold mb-4">
          Choose Your <span className="text-yellow-300">Tier</span>
        </h2>
        <p className="text-white/70 text-lg">
          Select the influencer tier that matches your campaign goals
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {tiers.map((tier) => (
          <button
            key={tier.id}
            onClick={() => onSelect(tier.id)}
            className={`relative p-8 rounded-[32px] md:rounded-[40px] border-2 transition-colors text-left group ${
              selectedTier === tier.id
                ? 'bg-yellow-300/10 border-yellow-300 shadow-lg shadow-yellow-300/20'
                : 'bg-white/5 border-white/10 hover:bg-white/10 hover:border-white/20'
            }`}
          >
            {/* Selected Indicator */}
            {selectedTier === tier.id && (
              <div className="absolute top-4 right-4 w-8 h-8 rounded-full bg-yellow-300 flex items-center justify-center text-black">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            )}

            {/* Icon */}
            <div
              className={`w-16 h-16 rounded-full mb-6 flex items-center justify-center text-3xl ${
                selectedTier === tier.id
                  ? 'bg-yellow-300 text-black'
                  : 'bg-white/10 text-yellow-300'
              }`}
            >
              {tier.icon}
            </div>

            {/* Title */}
            <h3
              className={`text-2xl font-bold mb-2 ${
                selectedTier === tier.id ? 'text-yellow-300' : 'text-white'
              }`}
            >
              {tier.name}
            </h3>

            {/* Description */}
            <p className="text-white/70 mb-6">{tier.impressions}</p>

            {/* Pricing */}
            <div className="space-y-2 text-sm mb-6">
              <div className="flex justify-between">
                <span className="text-white/50">Per QRT:</span>
                <span className="text-white font-semibold">${tier.qrtCost}</span>
              </div>
            </div>

            {/* Features */}
            <ul className="space-y-2">
              {tier.features.map((feature, index) => (
                <li key={index} className="flex items-start gap-2 text-white/80 text-sm">
                  <span className="text-yellow-300">✓</span>
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </button>
        ))}
      </div>

      <div className="bg-white/5 rounded-[24px] p-6 border border-white/10">
        <div className="text-sm text-white/70">
          💡 <strong>Tip:</strong> Most campaigns start with 40 to 65 creators for optimal reach
        </div>
      </div>
    </div>
  );
};

export default TierSelection;
